import React from 'react'
import { CouponDetailType } from 'types/coupon'
import CampaignItem from 'components/base-ui/CampaignItem'
import CampaignListSkeleton from './CampaignListSkeleton'
import { CampaignListSection, CampaignItemWrapper } from './styled'

interface RedemptionProps {
  campaigns: CouponDetailType[]
  loading: boolean
  memberTotalPoints: number
  onClickCampaign: (campaign: CouponDetailType) => void
}

const RedeemCampaign = ({ campaigns, loading, memberTotalPoints, onClickCampaign }: RedemptionProps) => {
  return loading ? (
    <CampaignListSkeleton quantity={12} />
  ) : (
    <CampaignListSection>
      {campaigns.map((item, index) => (
        <CampaignItemWrapper key={item.serialNumber} borderTop={index !== 0}>
          <CampaignItem campaign={item} memberTotalPoints={memberTotalPoints} onClick={onClickCampaign} />
        </CampaignItemWrapper>
      ))}
    </CampaignListSection>
  )
}

export default RedeemCampaign
